import { render, staticRenderFns } from "./MultiNavigationItem.vue?vue&type=template&id=c0f23ab0&scoped=true"
import script from "./MultiNavigationItem.vue?vue&type=script&lang=js"
export * from "./MultiNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./MultiNavigationItem.vue?vue&type=style&index=0&id=c0f23ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f23ab0",
  null
  
)

export default component.exports